var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.donation)?_c('v-alert',{staticClass:"alert ml-4 mr-4 mb-3",attrs:{"value":true,"type":"warning"}},[_vm._v("\n\tUwaga! Suma kwoty dotacji z projektu ("+_vm._s(_vm.formatMoney(_vm.donation))+" PLN) została przekroczona.\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }